import React, { useEffect, useState } from 'react';
import API from './api';

function AdminRouting() {
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState('');
  const [date, setDate] = useState('');
  const [fromTime, setFromTime] = useState('');
  const [toTime, setToTime] = useState('');
  const [availableTeachers, setAvailableTeachers] = useState([]);
  const [visitId, setVisitId] = useState('');
  const [mode, setMode] = useState('assign'); // 'assign' or 'reassign'
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      const res = await API.get('/students/all');
      setStudents(res.data);
    } catch (err) {
      console.error('Error fetching students:', err);
    }
  };

  const handleSearch = async () => {
    if (!selectedStudent || !date || !fromTime || !toTime) {
      setMessage('Please fill all fields');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const res = await API.get('/routing/available-teachers', {
        params: {
          date,
          from_time: fromTime,
          to_time: toTime,
          student_id: selectedStudent
        }
      });
      setAvailableTeachers(res.data);
    } catch (err) {
      console.error('Error fetching teachers:', err);
      setMessage('Error fetching teachers');
    } finally {
      setLoading(false);
    }
  };

  const handleAssignOrReassign = async (teacher) => {
    try {
      if (mode === 'assign') {
        await API.post('/visits', {
          student_id: selectedStudent,
          teacher_id: teacher.id,
          scheduled_at: `${date}T${fromTime}`
        });
        setMessage('Visit successfully assigned');
      } else if (mode === 'reassign') {
        if (!visitId) {
          setMessage('Please provide Visit ID for reassignment.');
          return;
        }
        await API.post('/routing/reassign', {
          visit_id: visitId,
          teacher_id: teacher.id,
          estimated_cost: teacher.estimated_cost,
          distance_km: teacher.distance_km,
          duration_min: teacher.duration_min
        });
        setMessage(`Visit ${visitId} reassigned to ${teacher.name}`);
      }
    } catch (err) {
      console.error('Error in assignment/reassignment:', err);
      setMessage('Operation failed');
    }
  };

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">Admin – {mode === 'assign' ? 'Assign Visit' : 'Reassign Visit'}</h2>

      <div className="mb-4">
        <label className="mr-2 font-semibold">Mode:</label>
        <select
          value={mode}
          onChange={(e) => setMode(e.target.value)}
          className="border px-2 py-1 rounded"
        >
          <option value="assign">Assign New Visit</option>
          <option value="reassign">Reassign Existing Visit</option>
        </select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <select
          className="p-2 border rounded"
          value={selectedStudent}
          onChange={(e) => setSelectedStudent(e.target.value)}
        >
          <option value="">-- Choose Student --</option>
          {students.map((s) => (
            <option key={s.id} value={s.id}>
              {s.first_name} {s.last_name}
            </option>
          ))}
        </select>

        {mode === 'reassign' && (
          <input
            type="number"
            className="p-2 border rounded"
            value={visitId}
            onChange={(e) => setVisitId(e.target.value)}
            placeholder="Visit ID to reassign"
          />
        )}

        <input
          type="date"
          className="p-2 border rounded"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />

        <input
          type="time"
          className="p-2 border rounded"
          value={fromTime}
          onChange={(e) => setFromTime(e.target.value)}
        />

        <input
          type="time"
          className="p-2 border rounded"
          value={toTime}
          onChange={(e) => setToTime(e.target.value)}
        />

        <button
          className="col-span-1 md:col-span-2 bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
          onClick={handleSearch}
        >
          Search Available Teachers
        </button>
      </div>

      {message && <p className="mt-4 text-red-500">{message}</p>}
      {loading && <p className="mt-4">Loading...</p>}

      {!loading && availableTeachers.length > 0 && (
        <div className="mt-6">
          <h3 className="text-lg font-semibold mb-2">Available Teachers</h3>
          <table className="w-full table-auto border border-gray-300 text-sm">
            <thead>
              <tr className="bg-gray-100">
                <th className="border px-2 py-1">Name</th>
                <th className="border px-2 py-1">Cost (€)</th>
                <th className="border px-2 py-1">Distance (km)</th>
                <th className="border px-2 py-1">Travel Time (min)</th>
                <th className="border px-2 py-1">Action</th>
              </tr>
            </thead>
            <tbody>
              {availableTeachers.map((t) => (
                <tr key={t.id}>
                  <td className="border px-2 py-1">{t.name}</td>
                  <td className="border px-2 py-1">{t.estimated_cost.toFixed(2)}</td>
                  <td className="border px-2 py-1">{t.distance_km.toFixed(1)}</td>
                  <td className="border px-2 py-1">{t.duration_min}</td>
                  <td className="border px-2 py-1 text-center">
                    <button
                      onClick={() => handleAssignOrReassign(t)}
                      className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600"
                    >
                      {mode === 'assign' ? 'Assign Visit' : 'Reassign'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AdminRouting;


